import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { getProgramDisplayLabel } from '@lyrahealth-inc/shared-app-logic/src/features/programConfigs/programHelpers'
import { ProgramNames } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'
import { IconBadge } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/iconBadge/IconBadge'
import { BadgeShape, BadgeVariant } from '@lyrahealth-inc/ui-core-crossplatform/src/badge/constants'

type ClientListSessionInfoProps = {
  programName?: ProgramNames | undefined
  isEngageDAProvider?: boolean
}

const ClientListProgramName: React.FC<ClientListSessionInfoProps> = ({ programName, isEngageDAProvider }) => {
  const intl = useIntl()
  const displayName = useMemo((): string | null => {
    if (!programName) {
      return null
    }
    return getProgramDisplayLabel(intl, programName, isEngageDAProvider ? 'daClientList' : 'clientProfile')
  }, [intl, programName, isEngageDAProvider])

  if (!displayName) {
    return null
  }
  return <IconBadge text={displayName} variant={BadgeVariant.INFO_SECONDARY} shape={BadgeShape.RECT} />
}

export default ClientListProgramName
